import {
  checkUserHasAdminRole,
  checkUserHasManagerRole,
  getLandingRoute,
} from "app/services/app.state.service";
import { Navigate } from "react-router-dom";
import { IqmsAdminView } from "app/components/iqms/IqmsAdminView";
import { IqmsManagerView } from "app/components/iqms/IqmsManagerView";

export const IqmsRouterFactory = () => {
  if (checkUserHasAdminRole()) {
    return <IqmsAdminView />;
  } else if (checkUserHasManagerRole()) {
    return <IqmsManagerView />;
  } else {
    // Not allowed here — route to the user's landing screen rather than
    // reloading the app, which would blank the screen on slower networks.
    return <Navigate to={getLandingRoute()} replace />;
  }
};

